<template>
  <v-container fluid fill-height grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <card
          color="green"
          title="Mitglieder Liste"
        >
          <v-data-table
            :headers="headers"
            :items="members"
            hide-actions
            :loading="loading"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.title }}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.phone }}</td>
              <td>{{ getBranchTitle(props.item.branch) }}</td>
              <td>{{ getBranchTitle(props.item.branch2) }}</td>
              <td width="156">
                <dlg-member-edit :member="props.item"/>
                <dlg-member-delete :member="props.item"/>
              </td>
            </template>
          </v-data-table>
        </card>
      </v-flex>
    </v-layout>

    <dlg-member-new/>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DlgMemberNew from '@/modules/member/_components/DlgMemberNew';
import DlgMemberEdit from '@/modules/member/_components/DlgMemberEdit';
import DlgMemberDelete from '@/modules/member/_components/DlgMemberDelete';
import Card from '../../../components/material/Card';

export default {
  name: 'list',
  components: {
    Card,
    DlgMemberDelete,
    DlgMemberEdit,
    DlgMemberNew,
  },
  data() {
    return {
      headers: [
        {
          text: 'Bezeichnung',
          align: 'left',
          value: 'title',
        },
        {
          text: 'Email',
          align: 'left',
          value: 'email',
        },
        {
          text: 'Telefonnummer',
          align: 'left',
          value: 'phone',
        },
        {
          text: 'Branche',
          align: 'left',
          value: 'branch',
        },
        {
          text: 'Branche#2',
          align: 'left',
          value: 'branch2',
        },
        {
          text: '',
          align: 'left',
          sortable: false,
          value: '',
        },
      ],
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      readUsers: 'member/read',
      readBranches: 'branch/read',
    }),
    getBranchTitle(id) {
      const branch = this.branches.filter(el => el.id === id)[0];
      if (branch) {
        return branch.title;
      }
      return '';
    },
  },
  computed: {
    ...mapGetters({
      members: 'member/all',
      branches: 'branch/all',
    }),
  },
  created() {
    this.loading = true;
    this.readUsers().then(() => {
      this.readBranches().then(() => {
        this.loading = false;
      });
    });
  },
};
</script>

<style scoped>

</style>
